import { Immutable } from "immer";
import React from "react";
import { prefillSSRRetailData } from "tsi-common-react/src/apps/retail/ssr";
import { useSSRStorePrefill } from "tsi-common-react/src/store/reducers";

import { templates } from "@reactivated";

import { RetailLocator } from "../RetailLocator";
import {
    SurveyTrigger,
    SurveyTriggerContext,
    noopSurveyTrigger,
} from "../StoreLocatorSurvey/context";
import { StoreLocatorSurvey } from "../StoreLocatorSurvey/index";

type IProps = Immutable<templates.StearnsRetailLocatorBlockTemplate>;

export const RetailLocatorSSR = (_props: IProps): React.JSX.Element => {
    useSSRStorePrefill({}, prefillSSRRetailData);

    // The survey modal is a sibling of the locator, so bridge the locator's
    // location-change event to the survey through a ref the survey populates.
    const surveyTriggerRef = React.useRef<SurveyTrigger>(noopSurveyTrigger);
    const registerTrigger = React.useCallback((trigger: SurveyTrigger) => {
        surveyTriggerRef.current = trigger;
    }, []);
    const triggerSurvey = React.useCallback<SurveyTrigger>((location) => {
        surveyTriggerRef.current(location);
    }, []);

    return (
        <SurveyTriggerContext.Provider value={triggerSurvey}>
            <section className="retail-locator">
                <RetailLocator />
            </section>
            <StoreLocatorSurvey onRegisterTrigger={registerTrigger} />
        </SurveyTriggerContext.Provider>
    );
};
